import { useQuery } from "@tanstack/react-query";
import useUserSettings from "features/User/hooks/useUserSettings";
import { getGeneralizedYesNoQueryResponse } from "helpers/api";
import { SearchParams } from "./useConsensusMeter";

/**
 * Hook to fetch the generalized yes/no query for a given search ID (non-thread search ID).
 * @param disabled - Whether to disable the query.
 * @returns The generalized yes/no query.
 */
export const useGeneralizedYesNoQuery = (
  searchParams: SearchParams,
  disabled: boolean = false
) => {
  const { searchId } = searchParams;

  const { lang } = useUserSettings();

  const { isLoading, data, isSuccess } = useQuery(
    ["generalized-yes-no-query", searchId],
    async () => {
      const res = await getGeneralizedYesNoQueryResponse(
        { threadSearchId: searchId! },
        {
          lang,
        }
      );
      return res.generalized_yes_no_query;
    },
    {
      enabled: !!searchId && !disabled,
    }
  );

  return {
    generalizedQuery: data,
    isQueryLoading: isLoading,
    isSuccess,
  };
};
